import { Injectable } from '@angular/core';
import {
	Router, Resolve,
	RouterStateSnapshot,
	ActivatedRouteSnapshot
} from '@angular/router';
import { NEVER, Observable, of } from 'rxjs';
import { JobDigitalLogFormInfo } from '../models/job-digital-log-form-info.model';
import { DocumentsService } from '../services/sections/documents/documents.service';
import { catchError, tap } from 'rxjs/operators';
import { GlobalSettingsService } from '../services/ui/global-settings.service';
import { Document } from '../models/document.model';

@Injectable({
	providedIn: 'root'
})
export class DlFormDocumentsResolver implements Resolve<Observable<JobDigitalLogFormInfo[]>> {
	constructor(
		private router: Router,
		private documentService: DocumentsService
	) { }

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

		GlobalSettingsService.isSecondaryLoaderLoading = true;

		return this.documentService
			.getDLFormDocuments(route.paramMap.get('token'))
			.pipe(
				catchError(() => {
					this.router.navigate(['/404']);
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					return NEVER;
				}),
				tap(() => {
					GlobalSettingsService.isSecondaryLoaderLoading = false;
				})
			);
	}
}
